import { find } from 'lodash'

import { WPPageData } from '@/types'

export const pageHasHero = (pageProps: WPPageData) => {
  const builder = pageProps?.acf?.builder || []
  return find(builder, { acf_fc_layout: 'hero' }) !== undefined
}
